module.exports = __webpack_public_path__ + "img/ic-fb.4bafed14.svg";